import { Tag } from '@phosphor-icons/react';
import MasterTable from './MasterTable';
import { mfgApi } from './mfgApi';

const CAT_API = {
  list: mfgApi.itemCategories,
  create: mfgApi.createItemCategory,
  update: mfgApi.updateItemCategory,
  remove: mfgApi.deleteItemCategory,
};
const CAT_LABELS = {
  title: 'mfg.category.title', desc: 'mfg.category.desc', name: 'mfg.category.name',
  namePh: 'mfg.category.namePh', add: 'mfg.category.add', empty: 'mfg.category.empty', usage: 'mfg.category.usage',
};

export default function Categories() {
  return (
    <div data-testid="mfg-categories">
      <MasterTable api={CAT_API} prefix="category" labels={CAT_LABELS} Icon={Tag} />
    </div>
  );
}
